export default __webpack_public_path__ + "static/media/dev_tools.d38d2d30.svg";